module.exports = __webpack_public_path__ + "img/cl_index_banner_logo.5232f8a9.png";